var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm26.67-113.27v1.43c0 8.75-7.09 15.84-15.84 15.84h-16.32c-8.75 0-15.84-7.09-15.84-15.84V224c0-9.1 5.19-17.43 13.33-21.5 30.61-15.31 50.67-26.54 50.67-42.5 0-19.39-14.02-40-40-40-17.93 0-33.13 11.84-38.2 28.12-2.15 6.9-8.11 11.88-15.33 11.88H124.3c-10.24 0-17.72-9.56-15.44-19.55 8.91-39.15 44-68.45 85.81-68.45 55.08 0 88 44.75 88 88 0 40.95-32.75 62.47-64 78.73z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerQuestion);
export default __webpack_public_path__ + "static/media/map-marker-question.7b65008c06836dca2e5a4e6b792cab14.svg";
export { ForwardRef as ReactComponent };